import { UnixDatePicker } from '../components'
import { datePickerSchema } from '../schemas'
import { withFormItem } from './form-item'

export const DatePickerRenderer = withFormItem(datePickerSchema)(childrenProps => {
  return <UnixDatePicker {...childrenProps} />
})
